"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioInput = void 0;
var mithril_1 = require("../../mithril");
var image_button_1 = require("../button/image.button");
var icons_1 = require("../icon/icons");
var theme_1 = require("../theme");
var radio_input_style_1 = require("./radio.input.style");
(0, theme_1.addStyles)(radio_input_style_1.Style);
exports.RadioInput = {
    view: function (state) {
        var classList = [
            radio_input_style_1.CSS.container,
            "".concat(radio_input_style_1.CSS.container, "--").concat(state.id),
            "".concat(radio_input_style_1.CSS.container, "--").concat(state.label.toLowerCase())
        ];
        if (state.disabled) {
            classList.push(radio_input_style_1.CSS.disabled);
        }
        var className = classList.join(' ');
        var onChange = function (e) { return exports.RadioInput.onChange(state); };
        return (0, mithril_1.m)('div', { className: className, onclick: onChange }, [
            state.value ? image_button_1.ImageButton.view(icons_1.MaterialIcon.RADIO_SELECTED) : image_button_1.ImageButton.view(icons_1.MaterialIcon.RADIO),
            (0, mithril_1.m)('span', { className: radio_input_style_1.CSS.label }, state.label)
        ]);
    },
    onChange: function (state) {
        state.setValue(true);
    }
};
//# sourceMappingURL=radio.input.js.map